import React from 'react';
import {Route, Routes} from "react-router-dom";
import Header from "./components/Header";
import {Container} from "react-bootstrap";
import {routeName} from "./utils/constants";
import MainPage from "./pages/MainPage";
import PrivacyPage from "./pages/PrivacyPage";
import {ThemeProvider} from 'styled-components';
import {theme} from './styles/theme';
import GlobalStyle from "./styles/globalStyles";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import DeleteAccountPage from "./pages/DeleteAccountPage";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle/>
            <div className={"d-flex flex-column"}>
                <Header/>
                <Container>
                    <Routes>
                        <Route path={routeName.home} element={<MainPage/>}/>
                        <Route path={routeName.privacy} element={<PrivacyPage/>}/>
                        <Route path={routeName.termsOfUse} element={<TermsOfUsePage/>}/>
                        <Route path={routeName.deleteAccount} element={<DeleteAccountPage/>}/>
                    </Routes>
                </Container>
            </div>
        </ThemeProvider>
    );
}

export default App;
